module.exports = __webpack_public_path__ + "img/Hypoxia-CECA_10X_CC.b711f406.png";